import { z } from 'zod'

export const DemographicsSchema = z
  .object({
    genderFemale: z.string().optional(),
    genderMale: z.string().optional(),
    genderOther: z.string().optional(),
    ethnicityAfricanAmerican: z.string().optional(),
    ethnicityAsian: z.string().optional(),
    ethnicityCaucasian: z.string().optional(),
    ethnicityEastAsian: z.string().optional(),
    ethnicityHispanicLatino: z.string().optional(),
    ethnicityMiddleEastern: z.string().optional(),
    ethnicityMultiracial: z.string().optional(),
    ethnicityNativeAmerican: z.string().optional(),
    ethnicityNativeHawaiian: z.string().optional(),
    ethnicityPreferNot: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const genderValidation = validateGenderTotal(data)
    if (!genderValidation.isValid) {
      ctx.addIssue({
        path: ['genderOther'],
        code: z.ZodIssueCode.custom,
        message: 'Total percentage must equal 100%',
      })
    } else {
      genderValidation.missingFields.forEach((field) => {
        ctx.addIssue({
          path: [field],
          code: z.ZodIssueCode.custom,
          message: 'Required if total is less than 100%',
        })
      })
    }

    const ethnicityValidation = validateEthnicityTotal(data)
    if (!ethnicityValidation.isValid) {
      ctx.addIssue({
        path: ['ethnicityPreferNot'],
        code: z.ZodIssueCode.custom,
        message: 'Total percentage must equal 100%',
      })
    } else {
      ethnicityValidation.missingFields.forEach((field) => {
        ctx.addIssue({
          path: [field],
          code: z.ZodIssueCode.custom,
          message: 'Required if total is less than 100%',
        })
      })
    }
  })

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateGenderTotal = (data: any) => {
  const fields = ['genderFemale', 'genderMale', 'genderOther']
  const values = fields.map((f) => parseFloat(data[f] || '0') || 0)
  const total = values.reduce((acc, val) => acc + val, 0)

  return {
    isValid: total === 100,
    missingFields: total < 100 ? fields.filter((f) => !data[f]) : [],
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateEthnicityTotal = (data: any) => {
  const fields = [
    'ethnicityAfricanAmerican',
    'ethnicityAsian',
    'ethnicityCaucasian',
    'ethnicityEastAsian',
    'ethnicityHispanicLatino',
    'ethnicityMiddleEastern',
    'ethnicityMultiracial',
    'ethnicityNativeAmerican',
    'ethnicityNativeHawaiian',
    'ethnicityPreferNot',
  ]
  const values = fields.map((f) => parseFloat(data[f] || '0') || 0)
  const total = values.reduce((acc, val) => acc + val, 0)

  return {
    isValid: total === 100,
    missingFields: total < 100 ? fields.filter((f) => !data[f]) : [],
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTotalDemographicsPercentage = (data: any) => {
  const fields = [
    'ethnicityAfricanAmerican',
    'ethnicityAsian',
    'ethnicityCaucasian',
    'ethnicityEastAsian',
    'ethnicityHispanicLatino',
    'ethnicityMiddleEastern',
    'ethnicityMultiracial',
    'ethnicityNativeAmerican',
    'ethnicityNativeHawaiian',
    'ethnicityPreferNot',
  ]
  const values = fields.map((f) => parseFloat(data[f] || '0') || 0)
  return values.reduce((acc, val) => acc + val, 0)
}
